module.exports = __webpack_public_path__ + "img/4.4107b9a7.png";